import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import { Dimensions, StyleSheet } from 'react-native';
import { FONT_WEIGHT_REGULAR } from '../../../styles/rn';
var screenWidth = Dimensions.get('window').width;
import { CustomStyleSheet } from '../../../utils/rn/tools';
var styles = CustomStyleSheet({
  keyAnswer: {
    width: '100%'
  },
  keyAnswer__loading: {
    height: 16,
    backgroundColor: 'linear-gradient(90deg, #f5f5f5 0.03%, rgba(225, 225, 225, 0.885183) 50.07%, #f5f5f5 100.03%)',
    margin: 12
  },
  keyAnswer__loading1: {
    width: '74%'
  },
  keyAnswer__loading2: {
    width: screenWidth - 24
  },
  keyAnswer__loading3: {
    width: '84%'
  },
  keyAnswer__error: {
    flexDirection: 'row',
    padding: 12,
    fontSize: 0
  },
  'keyAnswer-prompt-icon': {
    flexDirection: 'row',
    alignItems: 'center'
  },
  'keyAnswer-prompt-text': {
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.4)',
    marginLeft: 8
  },
  'keyAnswer-faq-container': {
    marginVertical: 4,
    // marginHorizontal: 12, // 这个没生效 改用下面俩行
    marginLeft: 12,
    marginRight: 12,
    paddingTop: 12,
    marginBottom: 20,
    paddingBottom: 4,
    borderTopWidth: 0.5,
    borderTopColor: '#e8e8e8',
    borderStyle: 'solid',
    marginTop: 12
  },
  'keyAnswer-faq-container-top12': {
    marginTop: 12,
    marginHorizontal: 0
  },
  'keyAnswer-faq-title': {
    flexWrap: 'wrap',
    lineHeight: 20,
    color: 'rgba(0, 0, 0, 0.54)'
  },
  'keyAnswer-faq-item': {
    flexWrap: 'wrap',
    marginTop: 12,
    color: '#4080ee',
    lineHeight: 20,
    fontSize: 16
  },
  'keyAnswer-faq-item__disabled': {
    color: 'rgba(0, 0, 0, 0.26)'
  },
  'keyAnswer-summary': {
    position: 'relative',
    overflow: 'hidden',
    paddingVertical: 8,
    paddingHorizontal: 12
  },
  'keyAnswer-gradient': {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 40,
    overflow: 'hidden'
  },
  'keyAnswer-btn': {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: 12,
    paddingHorizontal: 12,
    lineHeight: 16,
    color: '#EE4D2D',
    borderTopColor: 'rgba(0, 0, 0, 0.09)',
    borderTopWidth: 0.5,
    borderStyle: 'solid'
  },
  'keyAnswer-btn-text': {
    color: '#EE4D2D',
    fontSize: 14,
    lineHeight: 16
  },
  'keyAnswer-arrow': {
    flexDirection: 'row',
    marginLeft: 4
  },
  'keyAnswer-popup-content-container': {
    height: 'auto',
    paddingTop: 40,
    overflow: 'hidden'
  },
  'keyAnswer-popup-content': {
    margin: 0,
    padding: 0,
    paddingBottom: 24,
    flex: undefined
  },
  'keyAnswer-detail-content': {},
  'keyAnswer-supporting-message': {
    marginTop: 12
  },
  'keyAnswer-supporting-message__bottom': {
    marginBottom: 18
  },
  'key-answer-faq-ui-optimisation-container': {
    borderTopWidth: 0,
    marginBottom: 0
  },
  'key-answer-faq-ui-optimisation-item': {
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    paddingVertical: 12,
    paddingHorizontal: 0,
    // lineHeight: 16,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: 'rgba(0, 0, 0, 0.09)'
  },
  'key-answer-faq-ui-optimisation-item-text': _objectSpread(_objectSpread({}, FONT_WEIGHT_REGULAR), {}, {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 14,
    marginTop: 0,
    flex: 1,
    lineHeight: 16
  }),
  'key-answer-faq-title': _objectSpread(_objectSpread({}, FONT_WEIGHT_REGULAR), {}, {
    lineHeight: 16,
    fontSize: 14,
    paddingBottom: 12
  })
});
export default styles;